<template>
    <transition name="slide">
        <div class="menu-drawer" v-show="menuDrawer.visible">
            <div class="drawer-wrap-header">
                <i class="menu-drawer-close el-icon-close" @click="close"></i>
            </div>
            <div class="drawer-wrap-body">
                <div class="menu-drawer_uls" v-for="i in Math.ceil(menuChild.length/3)" :key="i">
                    <ul class="menu-drawer_ul" v-for="(item) of menuChild.slice((i - 1) * 3, Math.min(i * 3, menuChild.length))" :key="item.id">
                        <li class="menu-drawer_ul-head">
                            <i class="el-icon-setting"></i>{{item.category}}
                        </li>
                        <li class="menu-drawer_ul-item" :class="{ active: activeId == sItem.id}" v-for="(sItem) of item.child" :key="sItem.id" @click="clickMenuItem(sItem)">{{sItem.name}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            menuChild: [],
            activeId: null
        };
    },
    computed:{
        ...mapState({
            menuDrawer: (state) => state.index.menuDrawer,
            menuList: (state) => state.login.menuList,
        })
    },
    watch:{
        menuDrawer(val){
            if(val.visible){
                this.menuChild = this.menuList.filter(item => item.id == this.menuDrawer.id)[0].child || [];
            }
        }
    },
    methods: {
        // 收起菜单
        close() {
            this.$store.commit("SETMENUDRAWERVISIBLE", false);
        },
        // 点击菜单项
        clickMenuItem(sItem){
            this.activeId = sItem.id;
            this.$router.push({
                path: sItem.url
            });
            this.close();
        }
    },
};
</script>
<style lang="scss" scoped>
.menu-drawer {
    overflow: hidden;
    position: absolute;
    left: 200px;
    top: 0;
    width: 40%;
    height: 100%;
    background: $background-color-base;
    border-left: 1px solid #dddddd;
    z-index: 100;
    padding: 30px;
    box-sizing: border-box;
    z-index: 200;
    .drawer-wrap-header {
        .menu-drawer-close {
            position: absolute;
            right: 10px;
            top: 10px;
            font-size: 25px;
            cursor: pointer;
            &:active {
                opacity: 0.6;
            }
        }
    }
    .drawer-wrap-body {
        padding: 20px 0;
        .menu-drawer_uls {
            // display: flex;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-column-gap: 10px;
            justify-content: space-between; 
            padding-bottom: 24px;
            &+.menu-drawer_uls {
                padding-top: 24px;
                border-top: 1px solid #DCDFE6;
            }

            .menu-drawer_ul {
                li {
                    height: 40px;
                    line-height: 40px;
                    font-weight: 600;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                &-head {
                    color: #ada7aa;
                    font-size: 16px;
                    margin: 0 0 10px 0;
                    text-align: left;
                    i {
                        margin: 0 10px 0 0;
                    }
                }
                &-item {
                    color: $color-text-regular;
                    font-size: 12px;
                    text-align: left;
                    padding: 0 10px 0;
                    box-sizing: border-box;
                    cursor: pointer;
                    &:hover,
                    &.active {
                        color: $color-primary;
                        background: $menu-color-active;
                    }
                }
                & + .menu-drawer_ul {
                    // margin: 0 0 0 20%;
                }
            }
        }
    }
}

.slide-enter-active {
    animation: slide-in-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}
.slide-leave-active {
    animation: slide-out-left 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

/**
 * ----------------------------------------
 * animation slide-in-left
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-left {
    0% {
        -webkit-transform: translateX(-1000px);
        transform: translateX(-1000px);
        // opacity: 0;
    }
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
        // opacity: 1;
    }
}
@keyframes slide-in-left {
    0% {
        -webkit-transform: translateX(-1000px);
        transform: translateX(-1000px);
        // opacity: 0;
    }
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
        // opacity: 1;
    }
}

/**
 * ----------------------------------------
 * animation slide-out-left
 * ----------------------------------------
 */
@-webkit-keyframes slide-out-left {
    0% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
        opacity: 1;
    }
    100% {
        -webkit-transform: translateX(-1000px);
        transform: translateX(-1000px);
        opacity: 0;
    }
}
@keyframes slide-out-left {
    0% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
        opacity: 1;
    }
    100% {
        -webkit-transform: translateX(-1000px);
        transform: translateX(-1000px);
        opacity: 0;
    }
}
</style>